import { Box, GDSStyleObject, UtilityText } from '@leagueplatform/genesis-core';

type UnreadMessageIndicatorProps = {
  unreadMessageCount: number;
  children: React.ReactNode;
  css?: GDSStyleObject;
};

export function UnreadMessageIndicator({
  unreadMessageCount,
  children,
  css,
}: UnreadMessageIndicatorProps) {
  return (
    <Box
      css={{
        position: 'relative',
        width: 'fit-content',
        ...css,
      }}
    >
      {unreadMessageCount > 0 ? (
        <Box
          css={{
            position: 'absolute',
            right: 0,
            transform: 'translate(50%, -50%)',
            '@mobile': {
              transform: 'translate(25%, -25%)',
            },
            borderRadius: '50%',
            backgroundColor: '$decorativeBrandSecondaryPastel',
            pointerEvents: 'none',
            width: 23,
            height: 23,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <UtilityText
            aria-hidden
            css={{
              typography: '$caption',
              color: '$onSurfaceTextPrimary',
            }}
          >
            {unreadMessageCount}
          </UtilityText>
        </Box>
      ) : null}
      {children}
    </Box>
  );
}
